// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/GoToTopButton.module.css */
.GoToTopButton_goToTopButton__QCAo8 {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: var(--kur-amber);
  border: none;
  padding: 10px 15px;
  font-size: 18px;
  border-radius: 50%;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: opacity 0.3s ease-in-out;
  opacity: 1;
  z-index: 1000;
}
`, "",{"version":3,"sources":["webpack://./src/COMPONENTS/GO_TO_TOP/GoToTopButton.module.css"],"names":[],"mappings":"AAAA,4CAA4C;AAC5C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,wCAAwC;EACxC,oCAAoC;EACpC,UAAU;EACV,aAAa;AACf","sourcesContent":["/* src/components/GoToTopButton.module.css */\n.goToTopButton {\n  position: fixed;\n  bottom: 20px;\n  right: 20px;\n  background-color: var(--kur-amber);\n  border: none;\n  padding: 10px 15px;\n  font-size: 18px;\n  border-radius: 50%;\n  cursor: pointer;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n  transition: opacity 0.3s ease-in-out;\n  opacity: 1;\n  z-index: 1000;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"goToTopButton": `GoToTopButton_goToTopButton__QCAo8`
};
export default ___CSS_LOADER_EXPORT___;
